var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKebab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 5,
    "aria-hidden": "true",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 0c.61 0 1.14.223 1.59.67.449.446.673.973.673 1.58 0 .607-.224 1.134-.673 1.58-.45.447-.98.67-1.59.67-.61 0-1.14-.223-1.59-.67-.449-.446-.673-.973-.673-1.58 0-.607.224-1.134.673-1.58C7.86.223 8.39 0 9 0zm6.737 0c.61 0 1.14.223 1.59.67.448.446.673.973.673 1.58 0 .607-.225 1.134-.674 1.58-.449.447-.979.67-1.59.67-.61 0-1.14-.223-1.59-.67-.448-.446-.673-.973-.673-1.58 0-.607.225-1.134.674-1.58.449-.447.979-.67 1.59-.67zM2.263 0c.611 0 1.141.223 1.59.67.45.446.674.973.674 1.58 0 .607-.225 1.134-.674 1.58-.449.447-.979.67-1.59.67-.61 0-1.14-.223-1.59-.67C.226 3.384 0 2.857 0 2.25 0 1.643.225 1.116.674.67 1.123.223 1.653 0 2.264 0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKebab);
export default __webpack_public_path__ + "static/media/kebab.6e358dfa.svg";
export { ForwardRef as ReactComponent };